export const storeCheckoutEvent = (id: number) =>
{
    sessionStorage.setItem('checkoutEvent', id.toString());
}

export const clearCheckoutEvent = () => 
{
    sessionStorage.removeItem('checkoutEvent');
}

export const getCheckoutEvent = () =>
{
    const value = sessionStorage.getItem('checkoutEvent')
    return value ? parseInt(value,10) : 0;
}
